import BookingTime from './BookingTime';

export default BookingTime;
